import { render, staticRenderFns } from "./shopSelectSetting.vue?vue&type=template&id=0d151ed0&scoped=true&"
import script from "./shopSelectSetting.vue?vue&type=script&lang=js&"
export * from "./shopSelectSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d151ed0",
  null
  
)

export default component.exports